import zIndex from "@material-ui/core/styles/zIndex";

export default () => ({
  superContainer: {
    position: "relative",
    background: "#F9F9F9",
    // minHeight: `calc(${window.innerHeight}px - 64px)`,
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 1,
    flex: 1
  },
  form: {
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 1,
    flex: 1,
  },
  mainContainer: {
    width: "calc(100% - 85px)",
    margin: "auto",
    background: "white",
  },
  mainHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "white",
    borderTop: "1px solid #eeeeee",
    borderBottom: "1px solid #eeeeee",
    padding: "0",
    paddingRight: 20,
    paddingLeft: 20,
  },
  actionButton: {
    display: "flex",
    justifyContent: "space-between",
    width: 172,
    height: 32
  },
  buttonStyle: {
    width: 80,
    boxShadow: "none !important"
  },
  loader: {
    height: "100vh",
    background: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  colorPrimary: {
    color: "grey"
  },
  headerRight: {
    display: "flex",
    alignItems: "center"
  },
  btnStyle: {
    textTransform: "none",
    marginLeft: 12,
  },
  previewtabContainer: {
    margin: -16,
    marginTop: 0,
    paddingRigh: 20,
    background: "white",
    paddingLeft: 14,
    marginBottom: 0
  },
  previewContainer: {
    height: "calc(100vh - 148px)",
    overflow: "auto",
    paddingTop: 24,
    '&::-webkit-scrollbar': {
      dispaly: '0.4em'
    },
    '&::-webkit-scrollbar-track': {
      // boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      // webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      // backgroundColor: 'rgba(0,0,0,.1)',
      // outline: '1px solid slategrey'
    }
  },
  buttonContainer: {
    display: "flex",
    alignItems: "center",
    height: 20
  },
  buttonGroup: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    right: "0px",
    marginTop: "20px",
    zIndex: 5,
  },
  activeButton: {
    textTransform: "none",
    fontWeight: 400
  },
  inactiveButton: {
    color: "rgba(0, 0, 0, 0.5) !important",
    textTransform: "none",
    fontWeight: 400,
    "&:hover": {
      color: "#26bbed !important",
    }
  }
})